// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__SNHH0","balanceDisclaimer":"posDashboard_balanceDisclaimer__1HWpN"};